import { reqApiAgentNationList, useSWR } from '@/apis/ok'
import { useUserStore } from '@/store/user/useUserStore'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function useNationList() {
  const token = useUserStore((state) => state.token)
  const { i18n } = useTranslation()

  // 取得启用中所有国家 api
  const agentNationListQuery = useSWR<OK_API_AGENT_NATION_LIST.RES>(`/nation/list/${token}/${i18n.language}`, reqApiAgentNationList, {
    staleTime: 60 * 1000,
    enabled: !!token,
  })

  // 启用中所有国家 列表
  const nationList = useMemo(() => {
    return agentNationListQuery.data?.rows || []
  }, [agentNationListQuery.data])

  return {
    nationList, // 启用中所有国家 列表
  }
}
